const TEXTS = {
  DELETE_TASK_MODAL: {
    LABEL: 'Are you sure?',
    SUBMIT_LABEL: 'Delete',
    CANCEL_LABEL: 'Cancel',
    MESSAGE1: 'You cannot get the task back',
  },
};

export { TEXTS };
